import { Box, Button, Text } from '@simplywallst/ui-core';

import { CashValuationTooltip } from './components/CashValuationTooltip';

import { TitleWithTooltip } from '../TitleWithTooltip';
import { useState } from 'react';
import loadable from '@loadable/component';
import { ValuationFairValue } from '../ValuationFairValue';

const DCFRawDataModal = loadable(
  () => import('@/pages/CompanyReport/components/DCFRawData'),
  { resolveComponent: (c) => c.DCFRawDataModal }
);

type Props = {
  fairValue: number | undefined | null;
  intrinsicDiscount: number | undefined | null;
  uniqueSymbol: string;
  companyId: string;
  companyCurrencyISO: string;
};

export const ValuationOptionDcf = ({
  fairValue,
  intrinsicDiscount,
  uniqueSymbol,
  companyId,
  companyCurrencyISO,
}: Props) => {
  const [isValuationModalOpen, setIsValuationModalOpen] =
    useState<boolean>(false);
  return (
    <>
      <Box>
        <TitleWithTooltip tooltip={<CashValuationTooltip />}>
          Discounted Cash Flow Valuation
        </TitleWithTooltip>

        {fairValue && (
          <>
            <Button
              styleType="strongLink"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsValuationModalOpen(true);
              }}
            >
              <Text typography="tiny" color="brand01">
                {uniqueSymbol} valuation
              </Text>
            </Button>
            {isValuationModalOpen && (
              <DCFRawDataModal
                companyId={companyId}
                onClose={() => setIsValuationModalOpen(false)}
              />
            )}
          </>
        )}
      </Box>
      <ValuationFairValue
        fairValue={fairValue}
        intrinsicDiscount={intrinsicDiscount}
        currencyISO={companyCurrencyISO}
      />
    </>
  );
};
